<template>
  <div class="flow">
    <!-- 侧边菜单 -->
    <div class="aside">
      <div class="title">
        <i class="icon icon-yonghu2"></i>
        <span v-if="type === 'add'">{{ $t('base_user_item.xin_zeng_yuan_gong') }}</span>
        <span v-if="type === 'edit'">{{ $t('base_user_item.bian_ji_yuan_gong') }}</span>
      </div>
      <t-step v-model="step" :list="stepList" @change="changeStep"></t-step>
    </div>
    <!-- 内容区域 -->
    <div class="section">
      <!-- 0、用户信息 -->
      <user-item-step-user v-if="step === 0" :userId="userId" @cancel="onCancel" @step="onStep"></user-item-step-user>
      <!-- 1、加入部门 -->
      <user-item-step-organ v-if="step === 1" :userId="userId" @cancel="onCancel" @back="onBack" @step="onStep"></user-item-step-organ>
      <!-- 2、关联设备 -->
      <user-item-step-devices v-if="step === 2" :userId="userId" @cancel="onCancel" @back="onBack" @step="onStep"></user-item-step-devices>
      <!-- 3、关联岗位 -->
      <user-item-step-role v-if="step === 3" :userId="userId" @cancel="onCancel" @back="onBack" @step="onStep" :userName="userName"></user-item-step-role>
    </div>
  </div>
</template>

<script>
import tStep from '@/components/step.vue';
import userItemStepUser from './children/user_item_step_user.vue';
import userItemStepOrgan from './children/user_item_step_organ.vue';
import userItemStepDevices from './children/user_item_step_devices.vue';
import userItemStepRole from './children/user_item_step_role.vue';

export default {
  name: 'user_item',
  components: {
    tStep,
    userItemStepUser,
    userItemStepOrgan,
    userItemStepDevices,
    userItemStepRole,
  },
  data() {
    return {
      type: '',
      userId: '',
      userName: '',
      step: '',

    };
  },
  computed: {
    stepList() {
      return [
        {
          label: 1,
          value: 0,
          title: this.$t('base_user_item.yuan_gong_xin_xi'),
          subTitle: this.$t('base_user_item.lrygjbxx'),
        },
        {
          label: 2,
          value: 1,
          title: this.$t('base_user_item.jia_ru_bu_men'),
          subTitle: this.$t('base_user_item.xzyxbmjr'),
        },
        {
          label: 3,
          value: 2,
          title: this.$t('base_user_item.fen_pei_ji_qi'),
          subTitle: this.$t('base_user_item.fpjqgyggl'),
        },
        {
          label: 4,
          value: 3,
          title: this.$t('base_user_item.shou_yu_quan_xian'),
          subTitle: this.$t('base_user_item.sygwhszxx'),
        },
      ];
    }
  },
  mounted() {
    this.userId = this.getJump('userId') || '';
    this.type = this.userId ? 'edit' : 'add';
    this.step = this.stepList[0].value;
  },
  methods: {
    // 取消
    onCancel: function () {
      this.clearTagByKeep('user_item');
      const parentPath = this.getJump('parentPath');
      this.jump(parentPath, {}, true);
    },
    // 上一步
    onBack: function () {
      this.step--;
    },
    // 下一步
    onStep: function (val) {
      if (val.name === 'user') {
        this.userId = val.userId;
        this.userName = val.userName;
      }
      this.step++;
      this.clearKeepAlive('user');
    },
    // 变更步骤
    changeStep: function (item) {
      if (this.type === 'edit') {
        this.step = item.value;
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
</style>
